import { PageWidgetType } from '@efdigital/ll-addon-data';
import { DataTypeContent } from '@efdigital/ll-addon-data/data-types';
import type {
  PageWidgetEmbedHtml,
  PageWidgetEmbedHtmlLike,
} from '@efdigital/ll-addon-data/types/content/objects/page-widget-embed-html';
import { uniqueId } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';

import type {
  PageWidgetComponentSignature,
  WidgetEditor,
} from '../page-widget-signature.ts';

export class PageWidgetEmbedHtmlComponent extends Component<PageWidgetComponentSignature> {
  get widget() {
    return this.args.widget as PageWidgetEmbedHtml;
  }

  setEmbed = (event: Event) => {
    const embed = (event.target as HTMLInputElement).value;
    this.widget.embed = embed;
  };

  <template>
    {{#let (uniqueId) as |uniqueId|}}
      <div class="card-body">
        <div class="form-group mb-4">
          <label for="{{uniqueId}}-embed">Embed code</label>
          <textarea
            class="form-control"
            id="{{uniqueId}}-embed"
            rows="5"
            value={{this.widget.embed}}
            {{on "change" this.setEmbed}}
          />
        </div>
      </div>
    {{/let}}
  </template>
}

const DEFAULT_WIDGET_EMBED_HTML: Omit<PageWidgetEmbedHtmlLike, 'wid'> = {
  widgetType: PageWidgetType.EmbedHtml,
  title: 'Embed (Advanced)',
  css: '',
  embed: '',
};

export const EmbedHtmlWidgetEditor: WidgetEditor = {
  icon: 'ph:code-bold',
  label: 'Embed (Advanced)',
  component: PageWidgetEmbedHtmlComponent,
  dataType: DataTypeContent.PageWidgetEmbedHtml,
  widgetData: DEFAULT_WIDGET_EMBED_HTML,
};
